import {
  GET_ORG_SSO_STATUS, GET_ORG_SSO_STATUS_FAIL, GET_ORG_SSO_STATUS_SUCCESS,
  INVITE_CONFIRMATION, INVITE_CONFIRMATION_FAIL, INVITE_CONFIRMATION_SUCCESS
} from "./actionTypes";

export const inviteConfirmation = (data) => {
  return {
    type: INVITE_CONFIRMATION,
    payload: data,
  }
}

export const inviteConfirmationSuccess = success => ({
  type: INVITE_CONFIRMATION_SUCCESS,
  payload: success,
})

export const inviteConfirmationFail = error => ({
  type: INVITE_CONFIRMATION_FAIL,
  payload: error,
})

export const getOrgSsoStatus = () => {
  return {
    type: GET_ORG_SSO_STATUS,
  }
}

export const getOrgSsoStatusSuccess = success => ({
  type: GET_ORG_SSO_STATUS_SUCCESS,
  payload: success,
})

export const getOrgSsoStatusFail = error => ({
  type: GET_ORG_SSO_STATUS_FAIL,
  payload: error,
})